import { lazy } from "react";

const routes = [
  {
    path: "/village",
    element: lazy(() => import("../pages/Village")),
  },
  {
    path: "/village/add",
    element: lazy(() => import("../pages/Village/create")),
  },
  {
    path: "/village/edit/:id",
    element: lazy(() => import("../pages/Village/edit")),
  },
];

export default routes;
